module.exports = __webpack_public_path__ + "static/media/newChatLogo.7fee1ad8.png";